<template>
  <v-container :class="'main-container' + (showDesktopVersion ? '' : ' zero-padding')">
    <v-layout wrap>
      <page-header v-if="!showArticleOnly || $vuetify.breakpoint.smAndDown" />
      <top-menu v-if="!showArticleOnly && showDesktopVersion" />
      <left-menu v-if="!showDesktopVersion" />
      <right-menu v-if="!showDesktopVersion" />
      <template v-if="!showDesktopVersion">
        <v-container class="search-form-container">
          <search-form v-if="!showArticleOnly" />
        </v-container>
        <v-layout
          style="background:white; padding-bottom: 30px; width: 100%;"
          :class="showDesktopVersion ? 'mt-3' : ''"
        >
          <div
            class="right-col"
            id="content-area"
            :style="(showDesktopVersion
              ? 'width:calc(100% - 260px)'
              : '') + ';margin: 0px 10px;'"
            >
            <div
              style="padding: 0 5px;"
              v-html="selectedArticle['contentMobile_' + lang] || selectedArticle['content_' + lang]"
            />
            <booking-form v-if="showBookingForm" />
          </div>
        </v-layout>
      </template>
      <v-flex v-else xs12>
        <v-layout class="content-area" wrap>
          <div class="left-col">
            <search-form v-if="!showArticleOnly" />
            <facebook-frame />
            <main-share />
            <banners />
            <contact-banner />
          </div>
          <div
            class="right-col"
            id="content-area"
            :style="(showDesktopVersion
              ? 'width:calc(100% - 240px)'
              : '') + ';margin-left: 0px;'"
            >
              <div v-if="galleriesByArticleId[selectedArticle._id]">
                <object-images
                  :images="articleImages"
                  :compact="!showDesktopVersion"
                  :img-folder="'galleryImages/large'"
                />
              </div>
              <div v-html="selectedArticle['content_' + lang]"
              ></div>
              <booking-form v-if="showBookingForm" />
          </div>
        </v-layout>
      </v-flex>
      <page-footer />
    </v-layout>
  </v-container>
</template>

<script>
import sharedComputed from './sharedComputed'
import BookingForm from './../components/BookingForm'
import sharedMethods from './../methods/sharedMethods'
import LeftMenu from './../components/LeftMenu'
import RightMenu from './../components/RightMenu'
import { createHelpers } from 'vuex-map-fields'
import state from './../state.js'

const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField'
})

import PageHeader from './../components/_PageHeader'
import PageFooter from './../components/_PageFooter'
import SearchForm from './../components/SearchForm'
import TopMenu from './../components/TopMenu'

import FacebookFrame from './../components/_FacebookFrame'
import ContactBanner from './../components/_ContactBanner'
import MainShare from './../components/_MainShare'
import Banners from './../components/_Banners'
import ObjectImages from './../components/ObjectImages'

export default {
  name: 'Article',

  metaInfo () {
    return this.getMetaTags()
  },

  props: {
    id: {
      type: String,
      default: null
    }
  },

  components: {
    PageHeader,
    PageFooter,
    SearchForm,
    TopMenu,
    LeftMenu,
    RightMenu,
    FacebookFrame,
    ContactBanner,
    MainShare,
    Banners,
    ObjectImages,
    BookingForm
  },

  created () {
    this.metaTitle = this.metaSiteName
    this.metaUrl = this.defaultMetaUrl
    this.metaDescription = this.defaultMetaDescription
    this.metaImage = this.defaultMetaImage
    this.setContentAreaWidth()
  },

  mounted () {
    this.isHydrated = true
  },

  computed: {
    ...mapFields(Object.keys(state)),
    ...sharedComputed,

    showBookingForm () {
      return ['5bebc3ffa6f7db24edd92a80'].includes(this.selectedArticle._id)
    },

    articleImages () {
      if (!this.selectedArticle) { return [] }
      return this.galleriesByArticleId[this.selectedArticle._id] && this.galleriesByArticleId[this.selectedArticle._id][0]
        ? this.galleriesByArticleId[this.selectedArticle._id][0].galleryImages
        : []
    },

    selectedArticle () {
      if (this.pagesById[this.id]) {
        return this.pagesById[this.id]
      } else if (this.pagesBySeoName[this.id]) {
        let redirectArticleId = this.pagesBySeoName[this.id].articleId
        if (redirectArticleId) {
          return this.pagesById[redirectArticleId]
        }
        return this.pagesBySeoName[this.id]
      }
      return {}
    }
  },

  methods: {
    ...sharedMethods
  }
}
</script>
